<template>
	<div class="container mb-4 mt-5">
		<h1 class="text-center mb-4"> Start Make a Live Production</h1>
		<div  class="d-flex justify-content-around">
			<div v-for="(item, index) in items" :key="index" class="card mb-4 box-shadow">
				<div class="card-header text-center">
					<h4 class="my-0 font-weight-normal">{{ item.name }}</h4>
				</div>
				<div  class="card-body">
					<h1 class=" text-center  display-5">${{ item.price }} <small class="text-muted">/ mo</small></h1>
					<ul v-for="(feature, index) in item.packageFeatures" :key="index" class="list-unstyled mt-3 mb-4">
						<li>{{ feature.limit === 0 ? 'UNLIMITED' : feature.limit  }}
					{{ (feature.limit_type) }} of
					{{ (feature.feature_name) }} </li>
					</ul>
				</div>
					<button type="button" class="btn btn-lg btn-primary" @click="showPayment(item)">Sign up for free</button>
			</div>
		</div>
		<transition name="fade">
			<div v-show="isShowPayment" class="container text-center">
				<form @submit.prevent="">
					<div class="mb-3">
						<h2 class="font-weight-normal">{{ $t('Payment') }}</h2>
					</div>
					<div  class="form-group ">
						<input type class="form-control field  mb-3" placeholder="Name">
						<input type="email" name="email" class="form-control field  mb-3" placeholder="E-mail">
						<input v-model="promoCode" type="text" name="promo" class="form-control field  mb-3" placeholder="PROMO CODE">
						<div id="card-element" class="field "></div>
					</div>
					<div>
						<button class="btn btn-primary mb-2 mr-2" @click="checkout(currentItem)"> Pay For {{ currentItem.name }}</button>
						<button class="btn btn-primary mb-2 mr-2" @click="cancelBuy(currentItem)"> Cancel</button>
					</div>
				</form>
			</div>
		</transition>
		<!-- </div> -->
	</div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import { getAxiosErrorMessage } from '@/lib/helper';
import packagesApi from '@/api/packages';
import transactionApi from '@/api/transactions';
import userSubscriptionApi from '@/api/userSubscriptions';


// import { stripeKey, stripeOptions } from './stripeConfig.json';

export default {
	name: 'Checkout',

	data() {
		return {
			languageLabel: {
				en: 'English',
				no: 'Norsk',
			},
			items: [],
			totalItems: 0,
			lastPage: 0,
			isFetching: false,
			keyword: '',
			stripeAPIToken: 'pk_test_cEeFbGOnhljGBjRCCjp7h3dL00SPobqhFE',
			stripe: '',
			elements: '',
			card: null,
			stripeOptions: {
				// see https://stripe.com/docs/stripe.js#element-options for details
			},
			customer: {},
			name: 'fikuri',
			promoCode: '',
			isShowPayment: false,
			currentItem: {},
		};
	},
	created() {
		this.fetch();
		this.setNavbarVisible(0);
		this.setDrawerVisible(0);
	},
	beforeDestroy() {
		this.setDrawerVisible(true);
	},
	mounted() {
	},
	methods: {
		...mapActions({
			setLocale: 'setLocale',
			setNavbarVisible: 'setNavbarVisible',
			setDrawerVisible: 'setDrawerVisible',
			setUser: 'setUser',
		}),
		printUpperCase(text) {
			return text && typeof (text) === 'string' ? text.toUpperCase() : '';
		},
		showPayment(item) {
			this.isShowPayment = false;
			this.currentItem = item;
			this.isShowPayment = true;
			this.configureStripe();
		},
		cancelSubs(pkg) {
			const param = {
				user_id: this.user.id,
				package_id: pkg.id,
			};
			const callback = () => {
			};

			const errCallback = (e) => {
				const message = getAxiosErrorMessage(e);
				this.$notify({
					group: 'app',
					type: 'error',
					title: 'Failed to cancel Subscription',
					text: message,
				});
			};
			userSubscriptionApi.cancel(param, callback, errCallback);
		},
		checkout(pkg) {
			const param = {
				package_id: pkg.id,
			};
			if (this.promoCode) {
				param.promo_code = this.promoCode.toUpperCase();
			}
			const callback = (response) => {
				if (response && response.error) {
					this.$notify({
						group: 'app',
						type: 'error',
						title: 'Failed, Payment Declined',
						text: 'Failed, Payment Declined',
					});
				}
				this.customer = response.data;
				const card = this.card;
				this.createPaymentMethod({ card });
			};

			const errCallback = (e) => {
				const message = getAxiosErrorMessage(e);
				this.$notify({
					group: 'app',
					type: 'error',
					title: 'Failed, Payment Declined',
					text: message,
				});
			};
			transactionApi.checkout(param, callback, errCallback);
		},
		// eslint-disable-next-line no-unused-vars
		createPaymentMethod({ card, isPaymentRetry, invoiceId }) {
			// eslint-disable-next-line no-unused-vars
			const params = new URLSearchParams(document.location.search.substring(1));
			// eslint-disable-next-line no-unused-vars
			const customerId = this.customer.customer_id;
			// Set up payment method for recurring usage
			// const billingName = this.name;
			// eslint-disable-next-line no-unused-vars
			const priceId = this.customer.price_id;
			// eslint-disable-next-line no-undef
			this.stripe
				.createPaymentMethod({
					type: 'card',
					card,
					billing_details: {
						name: this.user.name,
						email: this.user.email,
					},
				})
				.then((result) => {
					// const transactionId = result.transaction_id;
					if (result.error) {
						const error = result.error;
						const message = error.message;
						this.$notify({
							group: 'app',
							type: 'error',
							title: 'Failed, Payment Declined',
							text: message,
						});
					} else if (isPaymentRetry) {
						// Update the payment method and retry invoice payment
						// retryInvoiceWithNewPaymentMethod({
						// 	customerId,
						// 	paymentMethodId: result.paymentMethod.id,
						// 	invoiceId,
						// 	priceId,
						// });
					} else {
						// Create the subscription
						this.createSubscription(result.paymentMethod.id);
					}
				});
		},
		createSubscription(paymentMethodId) {
			const trxId = this.customer.transaction.id;
			const params = {
				status: 'paid',
				transaction_id: trxId,
				payment_method_id: paymentMethodId,

			};
			const callback = (response) => {
				const subsData = response.data;
				const subsUser = subsData.user;

				this.setUser(subsUser);
				this.$router.push('/').catch(() => {});
			};
			const errCallback = (e) => {
				const message = getAxiosErrorMessage(e);
				this.$notify({
					group: 'app',
					type: 'error',
					title: 'Failed, Payment Declined',
					text: message,
				});
			};
			transactionApi.process(params, callback, errCallback);
		},
		configureStripe() {
			// eslint-disable-next-line no-undef
			this.stripe = Stripe(this.stripeAPIToken);
			this.elements = this.stripe.elements();
			this.card = this.elements.create('card', {
				style: {
					base: {
						iconColor: '#6051ff',
						color: 'white',
						lineHeight: '48px',
						fontWeight: 400,
						fontFamily: '"Open Sans", "Helvetica Neue", "Helvetica", sans-serif',
						fontSize: '15px',
						'::placeholder': {
							color: '#CFD7DF',
						},
					},
				},
			});
			this.card.mount('#card-element');
		},
		pay() {
			// createToken returns a Promise which resolves in a result object with
			// either a token or an error key.
			// See https://stripe.com/docs/api#tokens for the token object.
			// See https://stripe.com/docs/api#errors for the error object.
			// More general https://stripe.com/docs/stripe.js#stripe-create-token.
		},
		complete() {
		},
		onBuy() {
		},
		fetch(reset = false, page) {
			this.isFetching = true;
			if (reset) {
				this.page = 1;
				this.items = [];
			}
			if (page) this.page = page;
			const params = this.fetchParams;
			const callback = (response) => {
				const items = response.data;
				if (items.length < this.limit) this.isAll = true;
				this.items = items;
				this.totalItems = response.total;
				this.lastPage = response.lastPage;
				this.isFetching = false;
			};
			const errorCallback = (e) => {
				const message = getAxiosErrorMessage(e);
				this.$notify({
					group: 'app',
					type: 'error',
					title: 'Packages',
					text: message,
				});
				this.isFetching = false;
			};
			packagesApi.getList(params, callback, errorCallback);
		},
	},
	computed: {
		fetchParams() {
			const params = {
				page: this.page,
				limit: this.limit,
				order_by: this.orderBy,
				sort_by: this.sortBy,
			};
			const keyword = this.keyword.trim();
			if (keyword !== '') params.keyword = keyword;
			return params;
		},
		totalPages() {
			const total = Math.ceil(this.totalItems / this.limit);
			return total;
		},
		...mapGetters({
			user: 'user',
			locale: 'locale',
			isLoggingIn: 'isLoggingIn',
			loginError: 'loginError',
		}),
		action() {
			const { action } = this.$route.query;
			return action;
		},
		lang() {
			const lang = this.$route.query.lang || this.locale;
			return lang;
		},
		appVersion() {
			return process.env.VUE_APP_VERSION;
		},
	},

};
</script>

<style scoped>

.field {
	background-color: #212121;
	box-sizing: border-box;
	font-weight: 400;
	border: 1px solid #CFD7DF;
	border-radius: 24px;
	color: white;
	outline: none;
	flex: 1;
	height: 48px;
	line-height: 48px;
	padding: 0 20px;
	cursor: text;
}

.field::-webkit-input-placeholder { color: #CFD7DF; }
.field::-moz-placeholder { color: #CFD7DF; }

.field:focus,
.field.StripeElement--focus {
  border-color: #F99A52;
}
</style>
